<template>
  <div>
    <div class="row" style="margin-bottom: 100px">
      <div class="col-8">
        <div class="row">
          <div class="col-12">
            <b-card class="card--border">
              <div class="row">
                <div class="col-6">
                  <b-form-group label="Nome" label-for="datastart">
                    <b-input-group class="input-group-merge">
                      <b-input-group-prepend is-text>
                        <feather-icon icon="ClipboardIcon" />
                      </b-input-group-prepend>
                      <input v-model="form.title" placeholder="Digite o nome do formulário" class="form-control">
                    </b-input-group>
                  </b-form-group>
                </div>
              </div>
              <div class="row">
                <div class="col-6">
                  <!--            <b-input-group
                    prepend="Descrição"
                    class="">
                  </b-input-group>-->
                  <b-form-group label="Descrição" label-for="datastart">
                    <b-input-group class="input-group-merge">
                      <b-input v-model="form.description" placeholder="Descrição do formulário..." />
                    </b-input-group>
                  </b-form-group>
                </div>
              </div>
            </b-card>
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <app-collapse :type="'border'">
              <app-collapse-item v-for="(input, indexInput) in form.inputs" :key="`input_${indexInput}_${_uid}`"
                class="collapse-input" title="">
                <template #header>
                  <div>

                    <!--                      v-if="input.question != null"-->
                    <b-button class="btn-icon rounded-circle" size="sm" circle variant="danger"
                      @click="() => deleteQuestion(indexInput)">
                      <feather-icon icon="TrashIcon" />
                    </b-button>
                    <b class="ml-1">{{ input.question || 'Digite a sua pergunta...' }}</b>
                  </div>
                </template>
                <div class="row">
                  <div class="col">
                    <input v-model="input.question" type="text" class="form-control"
                      placeholder="Digite a sua pergunta...">
                  </div>
                  <div class="col">
                    <v-select v-model="input.type" :options="inputTypes" label="name" :reduce="input => input.value" />
                  </div>
                </div>
                <div class="row mt-1">
                  <div class="col">
                    <label>Obrigatório</label>
                    <b-form-checkbox v-model="input.required" class="custom-control-success form-control-sm"
                      name="user-leader" switch>
                      <span class="switch-icon-left">
                        <feather-icon icon="CheckIcon" />
                      </span>
                      <span class="switch-icon-right">
                        <feather-icon icon="XIcon" />
                      </span>
                    </b-form-checkbox>
                  </div>
                  <div class="col" v-if="['many_choose', 'unique_choose'].includes(input.type)">
                    <label>Opções de resposta</label>
                    <v-select v-model="input.options" label="name" taggable multiple />
                  </div>
                </div>
              </app-collapse-item>
            </app-collapse>
            <div class="mt-1 text-center">
              <b-button variant="primary" class="btn-icon" @click="newQuestion()">
                <feather-icon icon="PlusIcon" /> Nova pergunta
              </b-button>
            </div>
          </div>
        </div>
      </div>
      <div class="col">
        <forms-preview :prop-form="form" />
      </div>
    </div>

    <b-row style="bottom: 0; position: fixed;width: 80%;margin-left: 2%">
      <b-col>
        <b-card class="text-center">
          <b-button variant="primary" @click="() => saveForm()">
            Salvar
          </b-button>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import AppCollapse from '@core/components/app-collapse/AppCollapse.vue'
import AppCollapseItem from '@core/components/app-collapse/AppCollapseItem.vue'
import FormsPreview from '@/components/Forms/FormsPreview'

const INPUT_DEFAULT = {
  question: null,
  type: null,
  required: true,
  options: []
}

export default {
  name: "Forms",
  components: {
    AppCollapse,
    AppCollapseItem,
    FormsPreview
  },
  async mounted() {
    if (this.$route.params.id) {
      this.form = await this.$store.dispatch('forms/getFormById', this.$route.params.id)
    }
  },
  data() {
    return {
      form: {
        title: null,
        description: null,
        inputs: [],
      },
      inputTypes: [
        {
          value: 'short_text',
          name: 'Resposta curta',
        },
        {
          value: 'long_text',
          name: 'Parágrafo'
        },
        {
          value: 'unique_image',
          name: 'Imagem única'
        },
        {
          value: 'many_image',
          name: 'Várias imagens'
        },
        {
          value: 'unique_choose',
          name: 'Escolha única'
        },
        {
          value: 'many_choose',
          name: 'Multipla escolha'
        },
        {
          value: 'yes_no',
          name: 'Sim ou Não'
        },
      ]
    }
  },
  methods: {
    newQuestion() {
      this.form.inputs.push({ ...INPUT_DEFAULT })

      setTimeout(function () {
        const collapses = document.querySelectorAll('.collapse-input')
        const lastCollapse = [...collapses].pop().children[0]
        lastCollapse && lastCollapse.click()
      }, 1)
    },
    deleteQuestion(indexInput) {
      this.form.inputs.splice(indexInput, 1)
    },
    async saveForm() {
      await this.$store.dispatch('forms/saveForm', this.form)
    }
  }
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

.card--border {
  border-bottom: 10px solid $purple;
}
</style>
